import React from 'react';

const VIPReload = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.99707 11.9943C1.99707 17.5145 6.47211 21.9896 11.9924 21.9896C17.5126 21.9896 21.9876 17.5145 21.9876 11.9943C21.9876 6.47406 17.5126 1.99902 11.9924 1.99902C8.65576 1.99902 5.70101 3.63391 3.88548 6.14632",
      stroke: "white",
      strokeWidth: "1.49929",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M6 9.49539L9.49835 11.4944L11.9972 7.99609L14.496 11.4944L17.9943 9.49539L16.495 14.9928H7.49929L6 9.49539Z",
      stroke: "white",
      strokeWidth: "1.49929",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.25098 1.49922L3.77337 6.46949L8.74364 5.94709",
      stroke: "white",
      strokeWidth: "1.49929",
      strokeLinejoin: "round"
    }
  )
);

export { VIPReload };
//# sourceMappingURL=VIPReload.js.map
